@if(currentUser$ | async; as currentUser){
  <div style="overflow: hidden;">
  @if(!userIsCustomer()){
    <div
    class="sidebar__menu-wrapper"
    [ngClass]="options.isActiveSidebar || options.mobile ? 'sidebar-left__active' : 'sidebar__inactive'">
    @let canDisplayExpirationList = canDisplayExpirationList$ | async;
    <div [ngClass]="options.isActiveSidebar || options.mobile ? 'sidebar__menu-open' : 'sidebar__menu'">
      <div [ngClass]="options.isActiveSidebar || options.mobile ? 'bar-icons-wrapper-open' : 'bar-left__wrapper'">
        <div  [ngClass]="options.isActiveSidebar || options.mobile ? 'bar-menu-icons-open' : 'bar__menu-left'">
          <div  [ngClass]="options.isActiveSidebar || options.mobile ? 'bar-menu-icons-nav-open' : 'bar__menu-nav'">
            <ul>
              <li
                class="alarm__container"
                [ngClass]="activeMenuTab() == 'Notifications' && 'active'"
                (click)="updateMenuActive('Notifications')"
                title="Notifications"
              >
                <i class="fa-solid fa-bell text-gray-500"></i>
                @if(notificationsUnReadCount$ | async; as notificationsUnReadCount){
                    <span class="count right-0" >{{ notificationsUnReadCount }}</span >
                  }
              </li>

              <li
                class="expirations__container"
                [ngClass]="activeMenuTab() == 'My Tasks' && 'active'"
                (click)="updateMenuActive('My Tasks')"
                title="My Tasks"
              >
                <i class="fa-solid fa-list-check text-gray-500"></i>
                @if(tasksUnReadCount$ | async; as tasksUnReadCount){
                  <span class="count">{{ tasksUnReadCount }}</span>
                }
              </li>

              <li
                [ngClass]="activeMenuTab() == 'Messages' && 'active'"
                class="expirations__container"
                (click)="updateMenuActive('Messages')"
              >
                <i class="fa-solid fa-comment text-gray-500"></i>
                @if(unreadThreadsCount$ | async; as unreadThreadsCount){
                  <span class="count">{{ unreadThreadsCount }}</span>
                }
              </li>
              <li
                [ngClass]="activeMenuTab() == 'Users' && 'active'"
                class="users__container"
                (click)="updateMenuActive('Users')"
                title="Users"
              >
                <i class="fa-solid fa-users text-gray-500"></i>
              </li>
              @if (isBroker()) {
                <li
                  [ngClass]="activeMenuTab() == 'Auto-Assignees' && 'active'"
                  class="users__container"
                  (click)="updateMenuActive('Auto-Assignees')"
                  title="Auto-Assignees"
                >
                  <i class="fa-solid fa-user-check text-gray-500"></i>
                </li>
              }
              @if(canDisplayExpirationList){
                <li
                  [ngClass]="activeMenuTab() == 'Expirations' && 'active'"
                  class="expirations__container"
                  (click)="updateMenuActive('Expirations')"
                  title="Expirations"
                >
                  <i class="fa-solid fa-file-lines text-gray-500"></i>
                  @if(expiredDatesCount$ | async; as expiredDatesCount){
                    <span
                    class="count"
                    >{{ expiredDatesCount }}</span>
                  }
                </li>
              }
              @if(currentUser?.integrations?.ringCentral?.expiresAt && !options.isActiveSidebar && !options.mobile){
                @let expire = dateFromNow($safeNavigationMigration(currentUser?.integrations?.ringCentral?.expiresAt));
                <div class="mt-1 mb-3 mx-auto" style="background-color: var(--border-default); width: 80%; height: 1px;"></div>
                <li
                  [ngClass]="{
                    'bg-green-100 border-green-100': expire === 'green',
                    'bg-yellow-100 border-yellow-100': expire === 'yellow',
                    'bg-red-100 border-red-100': expire === 'red'
                  }"
                  class="flex flex-col items-center gap-2 mt-1 px-1 py-2"
                  style="border-radius: 5px; height: fit-content !important; border-top: 3px;"
                  (click)="openRingCentral()"
                  title="Refresh Ring Central"
                >
                  <img style="width: 20px;" src="../../../../assets/ring-central-icon.svg">
                  <i class="fa-solid fa-rotate" [ngClass]="{
                    'text-green-800': expire === 'green',
                    'text-yellow-800': expire === 'yellow',
                    'text-red-800': expire === 'red'
                  }" style="font-size: 12px;"
                  [style.rotate]="ringCentralSpinning ? '360deg' : '0deg'"
                  [style.transition]="'all 1s linear'"
                  ></i>
                </li>
              }
              @if(currentUser?.integrations?.dialpad?.hasCompanyToken && currentUser?.integrations?.dialpad?.senderPhoneNumber && !options.isActiveSidebar && !options.mobile){
                <div class="mt-1 mb-3 mx-auto" style="background-color: var(--border-default); width: 80%; height: 1px;"></div>
                <li
                  class="flex flex-col items-center gap-2 mt-1 px-1 py-2 bg-green-100 border-green-100"
                  style="border-radius: 5px; height: fit-content !important; border-top: 3px;"
                  title="Dialpad Status"
                >
                  <img style="width: 20px;" src="../../../../assets/dialpad-icon.png">
                  <i class="fa-solid fa-check text-green-800" style="font-size: 12px;"></i>
                </li>
              }
              <li
                [ngClass]="activeMenuTab() == 'Slack' && 'active'"
                class="expirations__container"
                (click)="updateMenuActive('Slack')"
                title="Slack status"
              >
                <i class="fa-brands fa-slack text-gray-500"></i>
              </li>
              @if(options.isActiveSidebar || options.mobile){
                  <li (click)="options.mobile ? onNavMobileClose.emit() : onActiveMenu.emit(false); activeMenuTab.set('')">
                    <i class="fas fa-times"></i>
                  </li>
              }
            </ul>
          </div>
        </div>
      </div>
      @if(options.isActiveSidebar || options.mobile){
        <div class="bar__menu-right">
          <!-- <div class="bar-content__title-wrapper">
            <div class="bar-content__title ">
              <p>{{ activeMenuTab() }}</p>
            </div>
          </div> -->

          <div class="side-bar-content-container">
                @if(activeMenuTab() == 'Notifications' || options.mobile && activeMenuTab() === ''){
                  <app-header-events [users]="users$ | async" [currentUser]="currentUser" type="notes" (onMobileClick)="onNavMobileClose.emit()" [options]="{
                    mobile: $safeNavigationMigration(options?.mobile)
                  }"></app-header-events>
                } @else if(activeMenuTab() == 'My Tasks'){
                    @defer (on viewport) {
                      <app-tasks-container
                        [fromStore]="fromSidebarStore"
                        [sidebar]="true"
                        [currentUser]="currentUser"
                        [resource]="{
                          resource: FOLLOW_UP_RESOURCE.COMPANY,
                          resourceId: $safeNavigationMigration(currentUser?.company?._id),
                          resourceName: $safeNavigationMigration(currentUser?.company?.name)
                        }"
                      ></app-tasks-container>
                    } @placeholder {
                      <span>Loading Tasks...</span>
                    }
                } @else if(activeMenuTab() == 'Messages'){
                <app-diesel-chat
                  [fromStore]="fromSidebarStore"
                  [currentUser]="currentUser"
                  [options]="{redirect: true, edit: true,  delete: true, archive: true}"
                ></app-diesel-chat>
              } @else if (activeMenuTab() == 'Users'){
                <app-sidebar-users></app-sidebar-users>
              } @else if (activeMenuTab() == 'Auto-Assignees' && isBroker()){
                <app-sidebar-auto-assignees></app-sidebar-auto-assignees>
              } @else if(activeMenuTab() == 'Expirations' && canDisplayExpirationList){
                <app-expiration-list [currentUser$]="currentUser$"></app-expiration-list>
              } @else if(activeMenuTab() == 'Slack'){
                <app-sidebar-slack></app-sidebar-slack>
              }
          </div>
        </div>
    }
  </div>

  </div>
}
</div>
}
